import { API_BASE } from "../config";

export async function requestResetLink(token: string, password: string): Promise<void> {
    const res = await fetch(`${API_BASE}/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password }),
    });

    if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        const message = errorData.error || "Failed to reset password";
        throw new Error(message);
    }
}
